// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#instructor-snapshot-container[data-v-58b2c807]{width:calc(100vw - 250px);height:82vh;overflow:auto;min-width:900px}", ""]);
// Exports
module.exports = exports;
